<template>
    <Card>
        <template v-slot:icon>
            <i class="fas fa-user-secret"/>
        </template>
        <template v-slot:title>
            Agency settings
        </template>
        <template v-slot:description>
            Assign the user to another agency.
        </template>

        <form>
            <FormGroupNew label="Agency"
                          :error="form.errors.agency_id"
                          required
            >
                <SelectAgency :agencies="agencies" @selected="agency => form.agency_id = agency.id"/>
            </FormGroupNew>
        </form>

        <template v-slot:footer>
            <SaveAndEnableButton :for="form" @click="submit"/>
        </template>
    </Card>
</template>

<script>
import Card from "@components/Cards/Card.vue";
import SaveAndEnableButton from "@components/Integrations/SaveAndEnableButton.vue";
import FormGroupNew from "@components/Form/FormGroupNew.vue";
import SelectAgency from "@components/Agency/SelectAgency.vue";

export default {
    components: {SelectAgency, FormGroupNew, SaveAndEnableButton, Card},

    props: {
        user: {
            type: Object,
            required: true
        },
        agencies: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            form: this.$inertia.form({
                agency_id: this.user.agency_id
            })
        }
    },

    methods: {
        submit() {
            this.form.patch(this.$route('user.agency.update', [this.user.url_key]))
        }
    }
}
</script>
